import { render } from "./TheProfessionalInterConsultationCreate.vue?vue&type=template&id=5e2d3021&ts=true"
import script from "./TheProfessionalInterConsultationCreate.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalInterConsultationCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__